@use "../../styles/breakpoint.module.scss" as *;

.scrollContainer {
    --slides-visible: 4;
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    @media ($below-tablet) {
        --slides-visible: 3;
    }

    @media ($below-mobile) {
        --slides-visible: 2;
    }

    > * {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: var(--width);
        gap: var(--gutter-width);
    }
}
